import Home from "./pages/Home";
import AdicionarObjetivo from "./pages/AdicionarObjetivo";
import AdicionarManualmente from "./pages/AdicionarManualmente";
import AportarMes from "./pages/AportarMes";
import OndeAportar from './pages/OndeAportar';
import ObjetivoDetalhes from './pages/ObjetivoDetalhes';
import ModalComplexo from "./components/ModalComplexoVue";
import ResumoPatrimonio from "./pages/ResumoPatrimonio";
import ReservaEgergencia from "./pages/ReservaEmergencia";
import CalendarioDividendo from "./pages/CalendarioDividendo";
import ModalDividendo from "./components/ModalDividendo";
// import Historico from "./pages/Historico";

const page = () => {
	if (document.querySelector('#home_page')) return Home;
	if (document.querySelector('#adicionarobjetivo_page')) return AdicionarObjetivo;
	if (document.querySelector('#adicionarmanualmente_page')) return AdicionarManualmente;
	if (document.querySelector('#aportarmes_page')) return AportarMes;
	if (document.querySelector('#resumo_patrimonio-page')) return ResumoPatrimonio;
	if (document.querySelector('#ondeaportar_page')) return OndeAportar;
	if (document.querySelector('#objetivodetalhes_page')) return ObjetivoDetalhes;
	if (document.querySelector('#reserva_emergencia')) return ReservaEgergencia;
	if (document.querySelector('#calendario_page')) return CalendarioDividendo;
	// if (document.querySelector('#historico_page')) return Historico;



	else return null
}


const versaoCacheSpan = document.querySelector('#versao-cache');

// versaoCacheSpan?.innerText = '10-11-2023'



// `Maska` vem de um CDN externo (base.html); se falhar, o boot do Vue não deve
// travar por causa disso, o watchdog abaixo cobre esse cenário.
const vMaska = typeof Maska !== 'undefined' ? Maska.vMaska : undefined


let app

const WATCHDOG_TIMEOUT_MS = 8000
const RETRY_STORAGE_KEY = 'vueBootRetried'

// Mostra uma tela de fallback (sem depender de Vue) quando o boot falha
// definitivamente, evitando expor o template cru ({* ... *}) ou tela em branco.
function showVueBootFallback() {
	const appEl = document.getElementById('app')
	if (appEl) appEl.classList.remove('vue-boot-pending')

	if (document.querySelector('.vue-boot-fallback')) return

	// Antes de desistir, tenta recarregar a página uma única vez
	// (cobre falhas transitórias de rede/CDN).
	if (!sessionStorage.getItem(RETRY_STORAGE_KEY)) {
		sessionStorage.setItem(RETRY_STORAGE_KEY, '1')
		window.location.reload()
		return
	}

	const fallback = document.createElement('div')
	fallback.className = 'vue-boot-fallback'
	fallback.innerHTML = `
		<p>Não foi possível carregar esta página. Verifique sua conexão e tente novamente.</p>
		<button type="button">Atualizar</button>
	`
	fallback.querySelector('button').addEventListener('click', () => window.location.reload())
	document.body.appendChild(fallback)
}

;(function () {
	const pageComponent = page()
	if (!pageComponent) return

	const appEl = document.getElementById('app')
	if (appEl) appEl.classList.add('vue-boot-pending')

	let mounted = false
	const watchdogTimer = setTimeout(() => {
		if (!mounted) showVueBootFallback()
	}, WATCHDOG_TIMEOUT_MS)

	try {
		app = Vue.createApp(pageComponent);
		app.config.globalProperties.$console = console.log
		app.config.errorHandler = (err) => {
			console.error(err)
			if (!mounted) showVueBootFallback()
		}
		if (vMaska) app.directive('maska', vMaska)
		app.component('modal-complexo', ModalComplexo);
		app.component('modal-dividendo', ModalDividendo);
		app.component('vue-datepicker', VueDatePicker)
		app.component('v-select', window["vue-select"]);
		app.mount("#app")

		mounted = true
		clearTimeout(watchdogTimer)
		sessionStorage.removeItem(RETRY_STORAGE_KEY)
		if (appEl) appEl.classList.remove('vue-boot-pending')
	} catch (error) {
		console.error(error)
		clearTimeout(watchdogTimer)
		showVueBootFallback()
	}
})()



window.instance = app;